/**
* ECHTINTERACTIE, http://wijzijnecht.nl
* Facets javascript needed jquery, lodash, getUrlHashVars
* Todo: add sorting, make ajax
**/
;var facetTurbo = (function ($, _, window) {
    
     var facetTurbo = function ($target) {     
        /**
        * Set local variables
        */
        this.currentHash = {
			    'filter': [],
                'page': 1
            };
    
        this.$target = $target; //is obj
        this.paginationObj = $('.pagination-list').children().length >= 1 ? $('a.page-number') : false; //pagination container
        this._init();
      
    };
    
    
    /**
    * Init
    */
    facetTurbo.prototype._init = function() {
        var self=this;
        
        this._applyUrlHash();
       
        //bind select boxen
		self.$target
		    .find('select')
		    .bind('change', function(){
    			var obj = $(this),
    				objData=obj.data(),
    				objId=objData.mother_category,
    				objVal= obj.val(),
    				filterObj={}; 	
    			
    			filterObj[objId] = objVal;
    			
    			
    			if(objVal==='false')
    				self._removeFilter(objId);
    			else 
    				self._addFilter(filterObj);
			});
        
        
        //bind if pagination
        if(self.paginationObj) {
			self.paginationObj.bind('click', function(e) {
				var obj=$(this),
                    objData=obj.data();

				self._goPage(objData.pagination);

				e.preventDefault();
			});
		}
    };
    
   
    /**
    * go to page function
    **/
    facetTurbo.prototype._goPage = function(number) {
        this.currentHash.page = parseInt(number);
        this._updateHashInURL();
    };
    
    
    /**
    * Add Filter function
    **/
    facetTurbo.prototype._addFilter = function(item) {
        var self = this;
            //push item to array
            self.currentHash.filter.push(item);
			//reset page
			self.currentHash.page = 1;
			
			self._updateHashInURL();
    };
    
    
    /**
    * Remove Filter function
    **/
    facetTurbo.prototype._removeFilter = function(item) {
        var self = this,
            oldItem = _.find(self.currentHash.filter, item)
            indexItem = self.currentHash.filter.indexOf(oldItem),
            removeItem = self.currentHash.filter.splice(indexItem,1);
		
		//reset page
        self.currentHash.page = 1;
		
		self._updateHashInURL();
    };
       
    
    /**
    * Update hash in url
    **/
    facetTurbo.prototype._updateHashInURL = function() {
        var self=this,
            hash = '?',
            index= 0;
                    
		for (var key in self.currentHash) {
			
			if (index>0) 
				hash += '&';
							
			index++;
			
			if (self.currentHash[key]) {
				//refactoren naar een switch, case filter en case page etc
				if(key=='filter' && self.currentHash[key].length > 1) {
    				var pipeBool = false,
    				    type = key;
    				
                    self.currentHash[key].forEach(function(value, key){
                        var filter = JSON.stringify(value);
                        
                        //remove }{ {}"
                        filter = filter.replace(/\}|\{|\[|\]|"/gi,'');
                        
                        if(!pipeBool) {
                            hash+=type+'='+filter 
                        } else {
                            hash+='|'+filter
                        }
            
                        pipeBool = true;
                    });
                    
    				
				} else if(key=='filter' && self.currentHash[key].length == 1){
                    
                    var filter = JSON.stringify(self.currentHash[key]);
                    
                    
                    //remove }{ {}"    
                    filter = filter.replace(/\}|\{|\[|\]|"/gi,'');
    				hash+=key+'='+filter 
    				
				} else if(key=='filter' && self.currentHash[key].length < 1) {
    				
				} else {
    				
                    hash += key + '=' + self.currentHash[key];
				}
            }
		}
		
		//console.log(self.currentHash, hash);
		window.location.href = hash;
    };   
       
        
    /**
    *  Reads the url hash and fires  backend request based on this
    */
    facetTurbo.prototype._applyUrlHash = function() {
        var self = this,
            urlHashVars = window.getUrlHashVars;
        
		for (var key in urlHashVars) {


			// Update our parameters based on URL hash
			switch (key) {
			
				case 'page':
					self.currentHash.page = parseInt(urlHashVars["page"]);
				break;
			
				case 'filter':
					var terms = urlHashVars["filter"].split('|'),
					    filters= [];
                        
                        //loop trough terms en make object
                        terms.forEach(function(value, key){

                            var term_select = value.split(':')[0],
                                term_value = value.split(':')[1],
                                obj = {};
                           
                            obj[term_select] = term_value;
                            
                            filters.push(obj);
                        });

                    if (terms.length === null) {
						self.currentHash.filter = {};
					} else {
						self.currentHash.filter = filters;
					}
					
				break;
			}
		}
		
		// If filter is no longer available in url hash then clear the filters array
		if (!('filter' in urlHashVars)) {
			//self.filters = [];
			self.currentHash.filter = [];
		}            
    };


    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize wizard for all elements tagged with `[max-words]`
         */
        var initTurbo = function () {
    
            $('#SortBox').each(function () {
                var $target = $(this);
               
                new facetTurbo($target);
            });
        };
       
        initTurbo();
    });
})(jQuery, _, window);